import { markDocumentAi } from '../extensions/bundled/documents/documentsStore';
import { aiEditedMarks } from '../services/ai/aiAuthorship';
import { useTeamsStore } from '../store/teamsStore';
import { sanitizeRichTextHtml } from '../utils/sanitizeHtml';
import { markdownToHtml } from '../utils/markdownToHtml';
import { renderBody } from '../mcp/markdown';

export const KEY_STEP = 1_000_000;

/** Directory entries returned to the model. A deep node_modules is 40k rows;
 *  the model needs enough to answer, not the whole tree. */
export const FTP_LIST_LIMIT = 200;

export const PERSONAL_DOC_SCOPE = { type: 'personal' };

/** Every team-documents scope the user currently belongs to. */
export function docTeamScopes() {
  const teams = useTeamsStore.getState().teams || [];
  return teams.filter((t) => t?.id != null).map((t) => ({ type: 'team', teamId: t.id }));
}

export function genId() {
  return (typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID())
    || `id-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

/**
 * A description / document body as the model reads it: the documents'
 * renderer shared with MCP (src/mcp/markdown.js `renderBody`), so an image is
 * a "🖼 Image: name" line (it used to vanish) and no decryption key can ride
 * along. Plain text, as these tools always returned.
 */
export const bodyText = (html) => renderBody(html || '', 'text');

/**
 * AI Act Art. 50(2): mark a document the assistant just wrote as AI-edited
 * (documentsStore.markDocumentAi). The body has landed by then, so a failed
 * mark is logged and never turns the write into an error.
 */
export async function markDocEdited(docId, bodyHtml, scope) {
  try {
    await markDocumentAi(docId, aiEditedMarks(bodyHtml), scope);
  } catch (err) {
    if (process.env.NODE_ENV !== 'test') console.warn('[ai] AI mark failed:', err);
  }
}

/** Turn AI-provided content into sanitized rich-text HTML for storage. */
export function toBodyHtml(content, format) {
  const html = format === 'html' ? String(content || '') : markdownToHtml(String(content || ''));
  return sanitizeRichTextHtml(html);
}
